/*
  File: src/api/series.js
  Purpose: Series API client for listing series for selection controls
*/
import { apiClient } from '../auth/api';

export const SeriesAPI = {
    async list({ limit = 50, offset = 0 } = {}) {
        const params = { limit, offset };
        const { data } = await apiClient.get('/series', { params });
        return data;
    }
};

export default SeriesAPI;


